// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

import {Banner} from '../Banner';

export const BannerWithMargin = styled(Banner)`
  margin: 12px 34px;
  gap: 32px;
`;
